"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const ClassService_1 = __importDefault(require("modules/classManager/ClassService"));
const ContentPageService_1 = __importDefault(require("modules/content/ContentPageService"));
const ContentService_1 = __importDefault(require("modules/content/ContentService"));
const ModuleEditorService_1 = __importDefault(require("modules/content/moduleEditor/ModuleEditorService"));
class CreateModuleItemsUtils {
}
_a = CreateModuleItemsUtils;
CreateModuleItemsUtils.create = async (modules, isExtraModule = false) => {
    const defaultClassIds = await _a.getDefaultClassIds();
    for (let index = 0; index < modules.length; index++) {
        const moduleItem = modules[index];
        const allSelectedPages = moduleItem.pages.filter((pageItem) => pageItem.isChecked);
        if (moduleItem.isChecked || allSelectedPages.length > 0) {
            const newModule = await ModuleEditorService_1.default.createItem({
                classes: defaultClassIds,
                name: moduleItem.title,
                extra: isExtraModule
            });
            if (newModule && newModule.id) {
                ContentService_1.default.lastCreatedModule = newModule.id;
                await _a.createPages(newModule.id, moduleItem.pages);
            }
        }
    }
};
CreateModuleItemsUtils.createPages = async (moduleId, pages) => {
    for (let index = 0; index < pages.length; index++) {
        const pageItem = pages[index];
        const payload = {
            page: {
                moduleId,
                content: pageItem.description,
                name: pageItem.title
            }
        };
        await ContentPageService_1.default.create(payload);
    }
};
CreateModuleItemsUtils.getDefaultClassIds = async () => {
    const classes = await ClassService_1.default.getBasicClass();
    const defaultClassIds = classes
        .filter((classItem) => classItem.defaultClass)
        .map((classItem) => classItem.id);
    return defaultClassIds;
};
exports.default = CreateModuleItemsUtils;
